<!--Modals-->
<ui-dialog
    [open]="isUnableToEditModalOpen"
    (closing)="closeUnableToEditModal()"
    (primaryButtonPressed)="closeUnableToEditModal()"
    [primaryButtonLabel]="'time-off-v3.close' | translate"
    header="{{ 'time-off-v3.unableToEditTimeOffRequest' | translate }}"
>
    <p>{{ 'time-off-v3.youAreUnableToEditThisTimeOffRequestWhileItIsInProgress' | translate }}</p>
</ui-dialog>
<ui-dialog
    [open]="isUnableToDeleteModalOpen"
    (closing)="closeUnableToDeleteModal()"
    (primaryButtonPressed)="closeUnableToDeleteModal()"
    [primaryButtonLabel]="'time-off-v3.close' | translate"
    header="{{ 'time-off-v3.unableToDeleteTimeOffRequest' | translate }}"
>
    <p>{{ 'time-off-v3.youAreUnableToDeleteThisTimeOffRequestWhileItIsInProgress' | translate }}</p>
</ui-dialog>

<ui-confirmation-dialog
    #deleteRequestModal
    header="time-off-v3.deleteTimeOffRequest"
    primaryButtonLabel="time-off-v3.delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    >{{ 'time-off-v3.areYouSureYouWantToDeleteThisTimeOffRequest' | translate }}</ui-confirmation-dialog
>
<ui-confirmation-dialog
    #resetRequestModal
    header="time-off-v3.resetTimeOffRequest"
    primaryButtonLabel="time-off-v3.reset"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    >{{
        'time-off-v3.thisWillOverrideAnyApprovalFlowStepsAndImmediatelyResetTheRequest' | translate
    }}</ui-confirmation-dialog
>
<ui-confirmation-dialog
    #forceApproveModal
    header="time-off-v3.areYouSure"
    primaryButtonLabel="time-off-v3.forceApprove"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    >{{
        'time-off-v3.thisWillOverrideAnyApprovalFlowStepsAndImmediatelyApproveTheRequest' | translate
    }}</ui-confirmation-dialog
>
<ui-confirmation-dialog
    #forceDenyModal
    header="time-off-v3.areYouSure"
    primaryButtonLabel="time-off-v3.forceDeny"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    >{{
        'time-off-v3.thisWillOverrideAnyApprovalFlowStepsAndImmediatelyDenyTheRequest' | translate
    }}</ui-confirmation-dialog
>
<app-deny-time-off-request-dialog
    [name]="timeOffRequest.employee.fullName"
    [headerTitle]="'time-off-v3.areYouSure' | translate"
    [timeOffDates]="timeOffRequest.startAtString + ' to ' + timeOffRequest.endAtString"
    [extraText]="'time-off-v3.thisWillOverrideAnyApprovalFlowStepsAndDeny' | translate"
    [primaryButtonLabel]="'time-off-v3.forceDenyRequest' | translate"
    [openDialog]="isForceDenyRequestCommentModalOpen"
    (confirmDenyRequest)="onConfirmForceDenyRequest($event)"
    (closeDenyRequestModal)="onCloseForceDenyRequestModal()"
>
</app-deny-time-off-request-dialog>
<div class="page-container max-width time-off-request" [class.loading]="isLoading || isUpdating">
    <app-header
        title="{{ 'time-off-v3.viewRequestFullName' | translate: { name: timeOffRequest.employee.fullName } }}"
        [back]="true"
        [backRoute]="backRoute"
        [contextMenu]="canViewMeatballsActions"
    >
        <a
            *ngIf="timeOffRequest.employeeId"
            [routerLink]="['/', 'employees', 'directory', timeOffRequest.employeeId, 'personal']"
            class="item view-profile-context"
            >{{ 'time-off-v3.viewProfile' | translate }}</a
        >

        <app-context-item
            *ngIf="canEdit"
            label="{{ 'time-off-v3.edit' | translate }}"
            (click)="onEdit()"
        ></app-context-item>
        <app-context-item
            label="{{ 'time-off-v3.delete' | translate }}"
            *ngIf="canDeleteRequest"
            (click)="onDelete()"
        ></app-context-item>
        <app-context-item
            label="{{ 'time-off-v3.reset' | translate }}"
            (click)="onReset()"
            *ngIf="canReset"
        ></app-context-item>
        <app-context-item
            label="{{ 'time-off-v3.forceApprove' | translate }}"
            (click)="onForceApprove()"
            *ngIf="canForceApprove"
        ></app-context-item>
        <app-context-item
            label="{{ 'time-off-v3.forceDeny' | translate }}"
            (click)="onForceDeny()"
            *ngIf="canForceDeny"
        ></app-context-item>
    </app-header>
    <ng-container *ngIf="!isLoading">
        <!--    Banners-->
        <div class="banners" *ngIf="hasBanners">
            <ui-banner variant="warning" *ngFor="let warning of warnings">
                <p>{{ warning }}</p>
            </ui-banner>
            <ui-banner variant="danger" *ngFor="let error of errors">
                <p>{{ error }}</p>
            </ui-banner>
        </div>
        <ui-card class="request-details" [withMargin]="false">
            <h2>{{ 'time-off-v3.requestDetails' | translate }}</h2>
            <div class="request-details-content">
                <!--Left Pane-->
                <div>
                    <div class="only-large">
                        <ng-container [ngTemplateOutlet]="dateRange"></ng-container>
                    </div>
                    <ui-inline-date-picker
                        #calendar
                        [startAt]="timeOffRequest.startAt"
                        [startDate]="timeOffRequest.startAt"
                        [endDate]="timeOffRequest.endAt"
                        [headerComponent]="calendarPickerHeader"
                        class="read-only"
                    ></ui-inline-date-picker>
                </div>
                <!--Right Pane-->
                <div class="vertical-labels">
                    <div class="hide-large">
                        <ng-container [ngTemplateOutlet]="dateRange"></ng-container>
                    </div>
                    <div class="vertical-label">
                        <div>{{ 'time-off-v3.timeOffType' | translate }}</div>
                        <div>{{ timeOffRequest.timeOffPolicy.timeOffType.name }}</div>
                    </div>
                    <div class="vertical-label">
                        <div>{{ 'time-off-v3.balanceBefore' | translate }}</div>
                        <div *ngIf="!timeOffRequest.timeOffPolicy.isUnlimited; else infinity">
                            {{ balanceBefore | i18nNum }}
                            {{
                                (timeOffRequest.showHourly ? 'time-off-v3.hours' : 'time-off-v3.days')
                                    | translate
                                    | titlecase
                            }}
                        </div>
                    </div>
                    <div class="vertical-label">
                        <div>{{ 'time-off-v3.countAs' | translate }}</div>
                        <div>{{ timeOffRequest.totalAmountWithUnit | appTranslate | titlecase }}</div>
                    </div>
                    <div class="vertical-label">
                        <div>{{ 'time-off-v3.description' | translate }}</div>
                        <div class="allow-overflow">
                            {{
                                timeOffRequest.description
                                    ? timeOffRequest.description
                                    : ('time-off-v3.noDescriptionProvided' | translate)
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </ui-card>
        <!--Approval Flow-->
        <ui-card [loading]="isLoadingApprovalFlow" [withMargin]="false" class="approval">
            <app-approval-flows
                [timeOffRequest]="timeOffRequest"
                (updating)="isUpdating = $event"
                (loading)="isLoadingApprovalFlow = $event"
                (reloadRequest)="reloadTimeOffRequest()"
            ></app-approval-flows>
        </ui-card>
        <!--Table-->
        <ui-card [withSpacing]="false" [withMargin]="false">
            <app-table
                [table]="overlappingRequestsTable"
                title="{{ 'time-off-v3.overlappingRequestsInDepartment' | translate }}"
                *ngIf="overlappingRequestsTable && canViewOverlaps"
                [noPadding]="true"
                [embedded]="true"
                [isResponsive]="true"
                [useStickyHeader]="false"
                [showOffset]="false"
                [showSearch]="false"
            >
                <app-empty-state
                    label="{{ 'time-off-v3.nobodyElseInYourDepartmentWillBeAway' | translate }}"
                ></app-empty-state>
            </app-table>
        </ui-card>
    </ng-container>
</div>

<ng-template #infinity>
    <mat-icon svgIcon="infinity"></mat-icon>
</ng-template>

<ng-template #dateRange>
    <div class="date-range-wrapper">
        <div>{{ startAtString }}</div>
        <mat-icon svgIcon="arrowRight" class="arrow-icon"></mat-icon>
        <div>{{ endAtString }}</div>
    </div>
</ng-template>
